import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useAuth } from 'context/AuthContext';
import Loader from 'components/Loader';

const AuthGuard = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) navigate('/', { replace: true });
  }, [isAuthenticated, isLoading, navigate]);

  if (isLoading) return <Loader isVisible={isLoading} />;

  if (!isAuthenticated) return null;

  return <>{children}</>;
};

export default AuthGuard;
